import moment from "moment";

/**
 * 주어진 array를 hierarchy 구조로 변경하여 return 함
 * 자식 items는 children으로 구성함
 * @param {*} arr
 * @param {*} idName
 * @param {*} parentIdName
 * @returns
 */
export const toHierarchy = (arr, idName = "id", parentIdName = "parentId") => {
  let map = {};
  let node;
  let res = [];
  let i;
  for (i = 0; i < arr.length; i += 1) {
    map[arr[i][idName]] = i;
    arr[i].children = [];
  }
  for (i = 0; i < arr.length; i += 1) {
    node = arr[i];
    if (node[parentIdName]) {
      if (arr[map[node[parentIdName]]]) {
        arr[map[node[parentIdName]]].children.push(node);
      }
    } else {
      res.push(node);
    }
  }
  return res;
};

/**
 * 주어진 array에서 currentId값의 부모Item을 찾는 함수
 * depth 레벨에 따라 d가 1인 경우 바로 윗 부모를
 * 2인 경우 조부모
 * Infinity인 경우 최상위 부모를 찾음
 * @param {*} arr
 * @param {*} currentId
 * @param {*} depth
 * @param {*} idName
 * @param {*} parentIdName
 * @returns
 */
export const findParentItem = (
  flatArr,
  currentId,
  depth = Infinity,
  idName = "id",
  parentIdName = "parentId"
) => {
  let map = {};
  for (let i = flatArr.length - 1; i >= 0; i--) {
    map[flatArr[i][idName]] = flatArr[i];
  }

  let currentItem = map[currentId];
  let parentItem = null;
  let parentId = null;
  let remainDepth = depth;

  while (remainDepth > 0) {
    parentId = currentItem[parentIdName];
    parentItem = map[parentId];
    if (!parentItem) {
      break;
    }

    currentItem = parentItem;
    remainDepth = remainDepth - 1;
  }

  return currentItem;
};

/**
 * String to JSON
 */
export const convertStrToJson = (str) => {
  try {
    const json = JSON.parse(str);
    return json;
  } catch (e) {
    return str;
  }
};

export const convertStrToJsonRecursive = (str) => {
  // TODO: 미완성
  return convertStrToJson(str);
  // try {
  //   const topObj = convertStrToJson(str);
  //   const newObj = {};
  //   Object.keys(topObj).forEach(k => {
  //     newObj[k] = convertStrToJsonRecursive(topObj[k]);
  //   })

  //   return newObj;
  // } catch (e) {
  //   return str;
  // }
};

/**
 * 1차원 array를 2차원 array로 변형
 * @param {*} array
 * @param {*} sizeX
 * @returns
 */
export const make2dArray = (array, sizeX) => {
  const addition = sizeX - (array.length % sizeX);
  let emptyArr = [];
  if (addition) {
    emptyArr = new Array(sizeX - (array.length % sizeX));
    emptyArr.fill(null);
  }
  const newArr = [...array, ...emptyArr];

  const result = new Array(Math.ceil(newArr.length / sizeX))
    .fill()
    .map(() => newArr.splice(0, sizeX));

  return result;
};

/**
 * flatArr에서 idArray의 id 값들의 조상들을 모두 찾아줌.
 * idArray를 포함하여 return 함
 * @param {*} flatArr
 * @param {*} idArray
 * @param {*} idName
 * @param {*} parentIdName
 * @returns
 */
export const findAncestors = (
  flatArr,
  idArray,
  idName = "id",
  parentIdName = "parentId"
) => {
  const recursiveFn = (_idArray) => {
    const parentIds = flatArr.reduce((acc, item) => {
      if (_idArray.includes(item[idName])) {
        acc.push(item[parentIdName]);
      }
      return acc;
    }, []);

    if (parentIds.length === 0) {
      return [];
    }

    return [...parentIds, ...recursiveFn(parentIds)];
  };

  const foundIds = [...idArray, ...recursiveFn(idArray)];
  const foundItems = flatArr.filter((item) => foundIds.includes(item[idName]));

  return foundItems;
};

export const findBtnStyle = (num = null) => {
  if (!num) return {};

  const data = [
    {},
    {
      btnExcel: { colorType: "default-outline", iconType: "btn_excel" },
      btnInit: { colorType: "default-outline", iconType: "btn_reset" },
      btnAdd: { colorType: "default-outline", iconType: "btn_add_w" },
      btnDel: { colorType: "default-outline", iconType: "btn_trash" },
      btnConfirm: { colorType: "sub1", iconType: "btn_ok" },
      btnConfirmW: { colorType: "main", iconType: "btn_confirm_w" },
      btnClose: { colorType: "sub1", iconType: "btn_close" },
      btnSave: { colorType: "main", iconType: "btn_save" },
    },
    {
      btnInit: { colorType: "default" },
      btnSave: { colorType: "main" },
      btnDel: { colorType: "sub1" },
    },
  ];

  if (!data[num]) return {};

  return data[num];
};

export const toCamelCase = (str) => {
  if (str.includes("-") || str.includes("_")) {
    str = str.toLowerCase();
  }
  return str.replace(/([-_][a-z])/g, (group) =>
    group.toUpperCase().replace("-", "").replace("_", "")
  );
};

export const convertKeysToCamelCase = (data) => {
  if (Array.isArray(data)) {
    return data.map((item) => convertKeysToCamelCase(item));
  } else if (typeof data === "object" && data !== null) {
    return Object.keys(data).reduce((result, key) => {
      const newKey = toCamelCase(key);
      result[newKey] = convertKeysToCamelCase(data[key]);
      return result;
    }, {});
  }
  return data;
};

export const toSnakeCase = (str) => {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};

export const convertKeysToSnakeCase = (data) => {
  if (Array.isArray(data)) {
    return data.map((item) => convertKeysToSnakeCase(item));
  } else if (typeof data === "object" && data !== null) {
    return Object.keys(data).reduce((result, key) => {
      const newKey = toSnakeCase(key);
      result[newKey] = convertKeysToSnakeCase(data[key]);
      return result;
    }, {});
  }
  return data;
};
//Editor 내용에 불필요한 Tag 삭제
export const removeHtmlTags = (input) => {
  // &nbsp;를 공백으로 변환
  let output = input.replace(/&nbsp;/g, " ");
  // HTML 태그를 제거
  output = output.replace(/<\/?[^>]+(>|$)/g, "");
  return output;
};

/**
 * 형변환 날짜 > 문
 * @param date typeof date
 * @param format yyyy-mm-dd..
 * @returns {string}
 */
export const dateToString = (date, format) => {
  moment(date).format(format.toUpperCase());
};

/**
 * comecode DataSource를 checkBoxlist로 변경하는 코드
 * @param dataArray datasource
 * @param key   value로 바꿔야 하는 값
 * @param value textLabel로 바꿔야 하는값
 * @returns {array}
 */
export const transformData = (array, idKey, nameKey) => {
  return array.map((item) => ({
    value: item[idKey],
    textLabel: item[nameKey],
  }));
};

export const getDate2String = (date, fmt) => {
  try {
    const d = date;
    const weekName = [
      "일요일",
      "월요일",
      "화요일",
      "수요일",
      "목요일",
      "금요일",
      "토요일",
    ];
    let format = fmt === undefined ? this.props.dateFormat : fmt;
    return format.replace(/(yyyy|yy|MM|dd|E|hh|mm|ss|a\/p)/gi, ($1) => {
      switch ($1) {
        case "yyyy":
          return d.getFullYear();
        case "yy":
          return (d.getFullYear() % 1000).toString().padStart(2, "0");
        //return e3.string.lPad(d.getFullYear() % 1000, 2);
        case "MM":
          return (d.getMonth() + 1).toString().padStart(2, "0");
        //return e3.string.lPad(d.getMonth() + 1, 2);
        case "dd":
          return d.getDate().toString().padStart(2, "0");
        //return e3.string.lPad(d.getDate(), 2);
        case "E":
          return weekName[d.getDay()];
        case "HH":
          return d.getHours().toString().padStart(2, "0");
        //return e3.string.lPad(d.getHours(), 2);
        case "hh":
          return (d.getHours() % 12 ? d.getHours() % 12 : 12)
            .toString()
            .padStart(2, "0");
        //return e3.string.lPad(d.getHours() % 12 ? d.getHours() % 12 : 12, 2);
        case "mm":
          return d.getMinutes().toString().padStart(2, "0");
        //return e3.string.lPad(d.getMinutes(), 2);
        case "ss":
          return d.getSeconds().toString().padStart(2, "0");
        //return e3.string.lPad(d.getSeconds(), 2);
        case "a/p":
          return d.getHours() < 12 ? "오전" : "오후";
        default:
          return $1;
      }
    });
  } catch {
    return date;
  }
};
